import { Link } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { paths } from '../../routes/paths';
import { cn } from '../../utils/cn';
import { buildGoalYearMarkers } from '../../utils/goalDisplayUtils';

function countLabel(count, one, many) {
  return count === 1 ? one : many.replace('{count}', String(count));
}

/** ds/card/year-dreams no .pen — fecho do vision board com o calendário anual. */
export function GoalsYearCalendarTeaser({ goals, annualMonths, year }) {
  const markers = buildGoalYearMarkers({ goals, annualMonths, year });
  const currentMonth = year === new Date().getFullYear() ? new Date().getMonth() + 1 : null;
  const dreamsLabel = countLabel(
    markers.dream.size,
    pt.goals.vision.yearFootDreamsOne,
    pt.goals.vision.yearFootDreamsMany,
  );
  const dutiesLabel = countLabel(
    markers.duty.size,
    pt.goals.vision.yearFootDutiesOne,
    pt.goals.vision.yearFootDutiesMany,
  );

  return (
    <section className="flex w-full min-w-0 flex-col gap-space-4 rounded-ds-lg border border-border bg-card p-space-5 shadow-sm">
      <div className="flex flex-col gap-space-1">
        <p className="type-section text-muted-foreground">{pt.goals.vision.yearEyebrow}</p>
        <p className="type-title-card text-card-foreground">
          {pt.goals.vision.yearTitle.replace('{year}', String(year))}
        </p>
        <p className="type-label text-muted-foreground">{pt.goals.vision.yearCardSub}</p>
      </div>

      <div className="flex items-end gap-space-1">
        {markers.monthLabels.map((label, index) => {
          const month = index + 1;
          const isDream = markers.dream.has(month);
          const isDuty = markers.duty.has(month);
          const isCurrent = month === currentMonth;
          return (
            <div key={label + month} className="flex min-w-0 flex-1 flex-col items-center gap-space-1">
              <div className="flex h-3 w-full items-center justify-center">
                {isDream ? (
                  <span className="h-2.5 w-2.5 rounded-full bg-sage-500 shadow-[0_2px_6px_theme(colors.sage.glow)]" aria-hidden />
                ) : null}
              </div>
              <div className="flex h-3 w-full items-center justify-center">
                {isDuty ? (
                  <span className="h-2.5 w-2.5 rounded-[3px] bg-warning-fg" aria-hidden />
                ) : null}
              </div>
              <div className="h-[3px] w-full rounded-full bg-track" />
              <p
                className={cn(
                  'type-chip w-full text-center text-muted-foreground',
                  isCurrent && 'font-bold text-sage-on-tint',
                )}
              >
                {label}
              </p>
            </div>
          );
        })}
      </div>

      <div className="flex flex-col gap-space-1">
        <div className="flex items-center gap-space-2">
          <span className="h-2.5 w-2.5 rounded-full bg-sage-500" aria-hidden />
          <span className="type-body-sm font-semibold text-card-foreground">
            {pt.goals.vision.legendDream}
          </span>
          <span className="type-chip text-muted-foreground">{pt.goals.vision.legendDreamDesc}</span>
        </div>
        <div className="flex items-center gap-space-2">
          <span className="h-2.5 w-2.5 rounded-[3px] bg-warning-fg" aria-hidden />
          <span className="type-body-sm font-semibold text-card-foreground">
            {pt.goals.vision.legendDuty}
          </span>
          <span className="type-chip text-muted-foreground">{pt.goals.vision.legendDutyDesc}</span>
        </div>
      </div>

      <div className="flex items-center justify-between gap-space-3 border-t border-border pt-space-3">
        <p className="type-label text-muted-foreground">
          {dreamsLabel} · {dutiesLabel}
        </p>
        <Link
          to={paths.calendar}
          className="inline-flex shrink-0 items-center gap-space-1 type-label font-semibold text-sage-on-tint hover:underline"
        >
          {pt.goals.vision.yearCardLink}
          <CaretRight className="h-3.5 w-3.5" weight="bold" aria-hidden />
        </Link>
      </div>
    </section>
  );
}
